module.exports = __webpack_public_path__ + "static/img/technology1.369f544f.png";